import { envConfig } from "@/config";

export const frontendDomains = {
	sit: ["classwize.sit.linewize.net", "sit.classwize.linewize.net"],
	stg: ["classwize.beta-1.linewize.net", "classwize.qoria-stg.cloud"],
	ause1: ["classroom.au-1.familyzone.io", "classwize.syd.edu.prd.familyzone.com", "classwize.syd-2.linewize.net"],
	usce1: [
		"classroom.us-1.familyzone.io",
		"us.classwize.qoria.cloud",
		"us.classroom.qoria.cloud",
		"classwize.lax.edu.prd.familyzone.com",
		"classwize.us-1.linewize.net",
		"classwize.syd-1.linewize.net",
	],
	euwe2: ["classwize.uk-1.linewize.net", "classwize.smoothwall.cloud"],
};

export function getClassroomApiUrl(frontendDomain: string): string {
	if (envConfig.MODE === "development" && envConfig.CLASSROOM_API_URL_OVERRIDE) return envConfig.CLASSROOM_API_URL_OVERRIDE;

	if (frontendDomains.sit.includes(frontendDomain)) return envConfig.CLASSROOM_API_URL_SIT;
	if (frontendDomains.stg.includes(frontendDomain)) return envConfig.CLASSROOM_API_URL_STG;
	if (frontendDomains.ause1.includes(frontendDomain)) return envConfig.CLASSROOM_API_URL_AUSE1;
	if (frontendDomains.usce1.includes(frontendDomain)) return envConfig.CLASSROOM_API_URL_USCE1;
	if (frontendDomains.euwe2.includes(frontendDomain)) return envConfig.CLASSROOM_API_URL_EUWE2;

	// Default to SIT region
	return envConfig.CLASSROOM_API_URL_SIT;
}

export function getCoursesApiUrl(frontendDomain: string): string {
	if (envConfig.MODE === "development" && envConfig.COURSES_API_URL_OVERRIDE) return envConfig.COURSES_API_URL_OVERRIDE;

	if (frontendDomains.sit.includes(frontendDomain)) return envConfig.COURSES_API_URL_SIT;
	if (frontendDomains.stg.includes(frontendDomain)) return envConfig.COURSES_API_URL_STG;
	if (frontendDomains.ause1.includes(frontendDomain)) return envConfig.COURSES_API_URL_AUSE1;
	if (frontendDomains.usce1.includes(frontendDomain)) return envConfig.COURSES_API_URL_USCE1;
	if (frontendDomains.euwe2.includes(frontendDomain)) return envConfig.COURSES_API_URL_EUWE2;

	// Default to SIT region
	return envConfig.COURSES_API_URL_SIT;
}

export function getPythonBackendUrl(frontendDomain: string): string {
	if (envConfig.MODE === "development" && envConfig.PYTHON_BACKEND_URL_OVERRIDE) return envConfig.PYTHON_BACKEND_URL_OVERRIDE;

	if (frontendDomains.sit.includes(frontendDomain)) return envConfig.PYTHON_BACKEND_URL_SIT;
	if (frontendDomains.stg.includes(frontendDomain)) return envConfig.PYTHON_BACKEND_URL_STG;
	if (frontendDomains.ause1.includes(frontendDomain)) return envConfig.PYTHON_BACKEND_URL_AUSE1;
	if (frontendDomains.usce1.includes(frontendDomain)) return envConfig.PYTHON_BACKEND_URL_USCE1;
	if (frontendDomains.euwe2.includes(frontendDomain)) return envConfig.PYTHON_BACKEND_URL_EUWE2;

	// Default to SIT region
	return envConfig.PYTHON_BACKEND_URL_SIT;
}

export function getScreenShareViewerUrl(frontendDomain: string): string {
	if (envConfig.MODE === "development" && envConfig.SCREENSHARE_VIEWER_URL_OVERRIDE) return envConfig.SCREENSHARE_VIEWER_URL_OVERRIDE;

	if (frontendDomains.sit.includes(frontendDomain)) return envConfig.SCREENSHARE_VIEWER_URL_SIT;
	if (frontendDomains.stg.includes(frontendDomain)) return envConfig.SCREENSHARE_VIEWER_URL_STG;
	if (frontendDomains.ause1.includes(frontendDomain)) return envConfig.SCREENSHARE_VIEWER_URL_AUSE1;
	if (frontendDomains.usce1.includes(frontendDomain)) return envConfig.SCREENSHARE_VIEWER_URL_USCE1;
	if (frontendDomains.euwe2.includes(frontendDomain)) return envConfig.SCREENSHARE_VIEWER_URL_EUWE2;

	// Default to SIT region
	return envConfig.SCREENSHARE_VIEWER_URL_SIT;
}

export function getClassroomScreenshotsApi(frontendDomain: string): string {
	if (envConfig.MODE === "development" && envConfig.CLASSROOM_SCREENSHOTS_API_OVERRIDE) return envConfig.CLASSROOM_SCREENSHOTS_API_OVERRIDE;

	if (frontendDomains.sit.includes(frontendDomain)) return envConfig.CLASSROOM_SCREENSHOTS_API_SIT;
	if (frontendDomains.stg.includes(frontendDomain)) return envConfig.CLASSROOM_SCREENSHOTS_API_STG;
	if (frontendDomains.ause1.includes(frontendDomain)) return envConfig.CLASSROOM_SCREENSHOTS_API_AUSE1;
	if (frontendDomains.usce1.includes(frontendDomain)) return envConfig.CLASSROOM_SCREENSHOTS_API_USCE1;
	if (frontendDomains.euwe2.includes(frontendDomain)) return envConfig.CLASSROOM_SCREENSHOTS_API_EUWE2;

	// Default to SIT region
	return envConfig.CLASSROOM_SCREENSHOTS_API_SIT;
}
